import { render, staticRenderFns } from "./DeleteSshKeyModal.vue?vue&type=template&id=20a4ff40&"
import script from "./DeleteSshKeyModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSshKeyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a4ff40')) {
      api.createRecord('20a4ff40', component.options)
    } else {
      api.reload('20a4ff40', component.options)
    }
    module.hot.accept("./DeleteSshKeyModal.vue?vue&type=template&id=20a4ff40&", function () {
      api.rerender('20a4ff40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Ssh/DeleteSshKeyModal.vue"
export default component.exports